import type { DiscussionReply } from './types';

export function latestVisibleDiscussionReply(replies: DiscussionReply[]): DiscussionReply | null {
  return replies.reduce<DiscussionReply | null>((latest, reply) => {
    if (reply.systemAction || reply.moderationStatus === 'reported' || reply.moderationStatus === 'hidden') return latest;
    return !latest || reply.createdAt > latest.createdAt || (reply.createdAt === latest.createdAt && reply.id > latest.id)
      ? reply
      : latest;
  }, null);
}
